<template>
  <div>
    <v-text-field
      v-model="color"
      hide-details="auto"
      class="ma-0 pa-0"
      :solo="!outlined"
      :outlined="outlined"
      :dense="dense"
      :label="label"
    >
      <template v-slot:append>
        <v-menu
          v-model="menu"
          top
          nudge-bottom="105"
          nudge-left="16"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <div :style="swatchStyle" v-on="on" />
          </template>
          <!-- <v-card> -->
          <v-card-text class="pa-0">
            <v-color-picker v-model="color" flat />
          </v-card-text>
          <!-- </v-card> -->
        </v-menu>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "blue",
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    swatchStyle() {
      const { color, menu } = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: "50%" ,
        marginTop:'0px',
        transition: "border-radius 200ms ease-in-out",
      };
    },
    color: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onchangeColor() {
      this.$emit("input", this.color);
    },
  },
};
</script>